
export default () => ({

    open: false,
    scrollPosition: null,

    toggle(){

        this.open = !this.open;

        if(this.open == true){
            this.lockBody();
        }else {
            this.releaseBody();
        }

    },

    lockBody(){
                
        let body = document.querySelector('body');

        this.scrollPosition = window.pageYOffset;

        body.style.overflow = 'hidden';
        body.style.position = 'fixed';
        body.style.top = `-${this.scrollPosition}px`;
        
    },

    releaseBody(){

        let body = document.querySelector('body');
        
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        window.scrollTo(0, this.scrollPosition);
        
    },

});